<template>
  <div class="password-input" :class="{ 'has-passScore': passScore }">
    <bam-field
      :message="
        v$.password.$invalid && v$.password.$dirty && validate
          ? 'Password length must be greater than 8 & match'
          : ''
      "
      :type="
        v$.password.$invalid && v$.password.$dirty && validate
          ? 'is-danger'
          : 'is-regular'
      "
    >
      <input-password
        :value="value"
        :show-score="passScore"
        :class="classes.primary"
        @input="handlePassword"
      />
    </bam-field>

    <bam-field
      v-if="confirm"
      :message="
        v$.passwordConfirm.$invalid && v$.passwordConfirm.$dirty && validate
          ? 'Password does not match'
          : ''
      "
      :type="
        v$.passwordConfirm.$invalid && v$.passwordConfirm.$dirty && validate
          ? 'is-danger'
          : 'is-regular'
      "
      :style="{ 'margin-top': spacing }"
    >
      <input-password
        :value="confirmPass"
        placeholder="Confirm Password"
        :disabled="v$.password.$invalid"
        :class="classes.secondary"
        :show-score="false"
        @input="handleConfirm"
      />
    </bam-field>
  </div>
</template>

<script>
import bamField from '@/shared/components/form-components/bam-field.vue';
import inputPassword from '@/shared/components/form-components/input-password.vue';
import { computed, defineComponent, reactive } from '@nuxtjs/composition-api';
import useVuelidate from '@vuelidate/core';
import { minLength, required, sameAs } from '@vuelidate/validators';

export default defineComponent({
  name: 'PasswordInput',
  components: {
    bamField,
    inputPassword,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    confirm: {
      type: Boolean,
      default: false,
    },
    confirmPass: {
      type: String,
      default: '',
    },
    spacing: {
      type: String,
      default: '0.5rem',
    },
    validate: {
      type: Boolean,
      default: true,
    },
    passScore: {
      type: Boolean,
      default: false,
    },
    classes: {
      type: Array,
      default: () => [],
    },
  },

  setup(_, { emit }) {
    const state = reactive({
      password: '',
      passwordConfirm: '',
    });

    const rules = computed(() => ({
      password: {
        required,
        minLength: minLength(8),
      },
      passwordConfirm: {
        required,
        sameAs: sameAs(state.password),
      },
    }));

    const v$ = useVuelidate(rules, state);

    const handlePassword = (value) => {
      v$.value.password.$model = value;
      state.password = value;

      emit('input', value);
      handleLocalError();
    };

    const handleConfirm = (value) => {
      v$.value.passwordConfirm.$model = value;
      state.passwordConfirm = value;

      emit('confirmPass', value);
      handleLocalError();
    };

    function handleLocalError() {
      if (!v$.value.$dirty) {
        return;
      }

      emit('error', v$.value.$invalid);
    }

    return {
      handleConfirm,
      handlePassword,

      passwordConfirm: state.passwordConfirm,
      v$,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '~assets/css/shared.scss';

.password-input.has-passScore
  .bam-field
  .input-password
  ::v-deep
  .passStrengthBars {
  display: flex;
}

.password-input.has-passScore ::v-deep .bam-field {
  height: remy(72);
}
</style>
